<template>
  <v-layout row wrap justify-space-around>
    <v-flex xs12>
      <v-subheader>GRUPOS</v-subheader>
      <v-card style="border-radius: 10px">
        <v-container fluid grid-list-md>
          <h3 v-if="!n_groups">Este campeonato não separa grupos.</h3>
          <v-layout row wrap justify-space-around v-if="n_groups">
            <v-flex v-for="(group, idx) in n_groups" :key="idx" lg3 sm4 xs12>
              <v-card style="border-radius: 10px">
                <v-card-title primary-title>
                  <v-toolbar flat color="white" light tabs>
                    <v-toolbar-title justify-centercolor="primary">Grupo {{group}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items v-if="is_owner">
                      <v-btn
                        small
                        icon
                        color="primary"
                        @click="addTeams2Group = true, one_group_index = idx"
                      >
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                </v-card-title>
                <v-spacer></v-spacer>
                <v-flex xs10 ml-2 v-if="n_groups">
                  <v-text-field
                    readonly
                    :value="team_group_selected[idx]? team_group_selected[idx][index]? team_group_selected[idx][index].team_name : null : null"
                    v-for="(team, index) in t_group"
                    :key="'tgs-'+index+idx"
                  ></v-text-field>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <div class="text-xs-center" v-if="false">
          <v-btn round color="primary" large dark mb-2 @click="/*updateGroups()*/">
            Salvar
            <v-icon right dark>check</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-flex>

    <v-dialog v-model="addTeams2Group" width="500" persistent v-if="addTeams2Group">
      <v-card class="pa-0">
        <v-card-title primary-title>
          <h2>Configurando grupo</h2>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat icon @click="addTeams2Group=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!--  TIREI A DIRETIVA ITEM-DISABLED PQ NAO TAVA FUNCIONANDO QUANDO PRECISA RETORNA-LA A LISTA. TEM Q ARRUMAR -->
          <v-select
            :items="teams"
            v-model="teams_of_one_group[index]"
            :label="`Time ${index+1}`"
            :key="'tgs-'+index"
            clearable
            v-for="(team, index) in t_group"
            item-text="team_name"
            return-object
          ></v-select>
          <!-- <v-text-field readonly @change="genGroups(idx, index)" v-model="team_group_selected2[index][idx]" :items="teams" item-text="team_name" return-object v-for="(team, index) in t_group" :key="'tgs-'+index+idx" ></v-text-field> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round class="white--text" @click="addTeams2Group = false" color="grey darken-2">
            <v-icon left small>fa-ban</v-icon>Cancelar
          </v-btn>
          <v-btn round class="white--text" color="primary" @click="updateGroup()">
            <v-icon left small>fa-check</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <card-loading v-if="loading" :loadText="loadTxt"></card-loading>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
import { setTimeout } from "timers";

import Api from "../../../api/index";

export default {
  props: {
    n_groups_prop_aux: {
      type: Number
    },
    t_group_prop_aux: {
      type: Number
    },
    edition_modality_id: {
      type: Number
    },
    teams_prop: {
      type: Array
    }
  },
  data() {
    return {
      teams: null,
      group_config: null,

      cards: [
        {
          title: "Jogo 1",
          src: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
          flex: 12,
          round: "1ª Rodada",
          roundID: 1
        }
        // { title: 'Jogo 2', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 12, round: '1ª Rodada', roundID: 1 },
        // { title: 'Jogo 3', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 12, round: '1ª Rodada', roundID: 1 },
        // { title: 'Jogo 12', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 12, round: '2ª Rodada', roundID: 2},
      ],
      rounds: [
        { name: "1ª Rodada", id: 1 }
        //    {name: '2ª Rodada', id: 2},
        //    {name: '3ª Rodada', id: 3},
        //    {name: 'Oitavas de Final', id: 4},
      ],
      number_groups: 4,
      teams_per_group: 4,
      select: [],

      addTeams2Group: false,
      one_group_index: null,
      teams_of_one_group: new Array(this.t_group),

      loading: false,
      loadTxt: null,

      team_group_selected: new Array(this.n_groups),
      team_group_selected2: [
        [],
        [],
        []
        // [],
        // {id: 1, teams: []},
        // {id: 2, teams: []},
        // {id: 3, teams: []},
        // {id: 4, teams: []},
      ],
      items: ["Inter São Judas", "Vasco", "Peñarol", "Sorridentes"]
    };
  },
  computed: {
    // n_groups() {
    //   if (this.oneChampionship) {
    //     return this.oneChampionship.data.attributes.edition.data[0].attributes
    //       .edition_modality.data.attributes.group_config.data.attributes
    //       .number_groups;
    //   } else {
    //     return 0;
    //   }
    // },
    // n_teams() {
    //   if (this.oneChampionship) {
    //     return this.oneChampionship.data.attributes.edition.data[0].attributes
    //       .edition_modality.data.attributes.group_config.data.attributes
    //       .teams_per_group;
    //   } else {
    //     return 0;
    //   }
    // },
    is_owner() {
      return this.oneChampionship.data.attributes.can_edit;
    },
    n_groups() {
      if (this.group_config) {
        return this.group_config.number_groups;
      }
    },
    t_group() {
      if (this.group_config) {
        return this.group_config.teams_per_group;
      }
    },
    ...mapState({
      oneChampionship: state => state.Championship.oneChampionship,
      user: state => state.Users.user,
      allChampTeams: state => state.ChampTeam.allChampTeams,

      updateTeamWasGood: state => state.Championship.updateTeamWasGood,
      updateTeamMessage: state => state.Championship.updateTeamMessage
    })
  },
  methods: {
    getChampTeams(id) {
      Api.Championship.indexChampTeams(id)
        .then(r => r.data)
        .then(data => {
          this.teams = data;
          // console.log({data});
        });
    },
    getGroupConfig(id) {
      Api.Championship.indexGroupConfiguration(id)
        .then(r => r.data)
        .then(data => {
          // console.log({data});
          this.group_config = data[0];
        });
    },
    initGroups() {
      var group = new Array(this.n_groups);
      // this.teams[0].group = 1
      // this.teams[1].group = 2
      // this.teams[2].group = 3
      for (let group_idx = 0; group_idx < this.n_groups; group_idx++) {
        group[group_idx] = this.teams.filter(obj => obj.group == group_idx + 1);
      }

      this.team_group_selected = group;
    },
    updateGroup() {
      this.loading = true;
      this.loadTxt = "Salvando";

      let teams_from_group = this.teams.filter(
        obj => obj.group == this.one_group_index + 1
      );
      let arr_team_name = this.teams_of_one_group
        .filter(obj => obj)
        .map(obj => obj.team_name);

      // console.log({ teams_from_group });
      // console.log({ arr_team_name });

      let excluded_teams_from_group = teams_from_group.filter(
        obj => !arr_team_name.includes(obj.team_name)
      );
      // console.log({ excluded_teams_from_group });

      this.teams_of_one_group.forEach(team => {
        if (team) this.updateChampTeam({ champTeam: team });
      });

      if (excluded_teams_from_group.length > 0) {
        excluded_teams_from_group.forEach(team => {
          if (team) {
            team.group = null;
            this.updateChampTeam({ champTeam: team });
          }
        });
      }
      setTimeout(() => {
        this.getChampTeams(this.$route.params.id);
      }, 1200);
    },
    ...mapActions({
      // getOneChampionship: "Championship/show",
      // getChampTeams: "ChampTeam/index",
      updateChampTeam: "Championship/updateChampTeam"
    })
  },
  watch: {
    oneChampionship(nv, ov) {
      if (nv) {
        this.number_groups = this.n_groups;
        this.teams_per_group = this.n_teams;
      }
    },

    teams_of_one_group(nv, ov) {
      if (nv) {
        let helper;
        this.teams.forEach((team, idx) => {
          helper = nv.filter(
            obj =>
              obj &&
              obj.hasOwnProperty("team_name") &&
              obj.team_name == team.team_name
          );
          if (helper && helper.length > 0) {
            team.group = this.one_group_index + 1;
          } else {
            // team.group = null
          }
        });
      }
    },
    updateTeamWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
          this.addTeams2Group = false;
          this.one_group_index = null;
        }, 200);
        this.teams_of_one_group = [];
        // this.getChampTeams(this.$route.params.id)
        // this.getOneChampionship({ id: this.$route.params.id });
      } else if (nv == false) {
      }
    },
    addTeams2Group(nv, ov) {
      if (nv) {
        let arr_team_name = this.team_group_selected[this.one_group_index].map(
          obj => obj.team_name
        );
        this.teams_of_one_group = this.teams.filter(obj =>
          arr_team_name.includes(obj.team_name)
        );
      }
    },
    oneChampionship(nv, ov) {
      this.initGroups();
    },
    teams(nv, ov) {
      if (nv) {
        this.initGroups();
      } else if (nv == false) {
      }
    }
  },
  mounted() {
    // this.genGroupsInit()
    // if (!this.allChampTeams) {
    this.getChampTeams(this.$route.params.id);
    // }
    this.getGroupConfig(this.$route.params.id);
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
</style>